import { asyncComponentFactory } from '@utils';

const AppComponents = {
  // NAV Components ------------------------------------------------------------
  MainNav: asyncComponentFactory('nav/MainNav'),
  MobileNav: asyncComponentFactory('nav/MobileNav'),
  //LazyLoader: asyncComponentFactory('nav/LazyLoader'),
  //QueryLazyLoader: asyncComponentFactory('nav/QueryLazyLoader'),
  // UI Components ------------------------------------------------------------
  //Accordion: asyncComponentFactory('ui/Accordion'),
  Drawer: asyncComponentFactory('ui/Drawer'),
  //Collapsible: asyncComponentFactory('ui/Collapsible'),
  Slider: asyncComponentFactory('ui/Slider'),
  Modal: asyncComponentFactory('ui/Modal'),
  MediaPlayer: asyncComponentFactory('ui/MediaPlayer'),
  Quicksearch: asyncComponentFactory('ui/Quicksearch'),

  // Footer: asyncComponentFactory('ui/Footer'),

  // CONTENT Components ------------------------------------------------------------
  Statistics: asyncComponentFactory('content/Statistics'),


};

export default AppComponents;
